import { asyncRouterMap, constantRouterMap } from '@router'
import { SET_ROUTER_LIST } from '../mutation-types'

function hasPermission(role, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(role)
  } else {
    // 没有设置meta.role就默认所有角色都可以访问
    return true
  }
}

// 过滤动态路由,routes : 前端设置好的路由表 role :当前角色
function filterAsyncRouter(routes, role) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    console.log(tmp, '当前的路由row')
    // 每一个路由进行一次判断,当前的用户角色是否被允许访问,存在权限则将该路由添加到过滤后的路由表
    if (hasPermission(role, tmp)) {
      //有子路由则递归处理
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, role) // 重新赋值过滤后的子路由表
      }
      // 存在权限则将该路由添加到过滤后的路由表
      res.push(tmp)
    }
  })
  console.log(res, '每一次的res')

  return res
}

const permission = {
  state: {
    routerList: constantRouterMap,
    permissionList: [],
    // role:''
  },
  getters: {
    routerList: state => state.routerList,
    permissionList: state => state.permissionList,
  },
  mutations: {
    [SET_ROUTER_LIST](state, routers) {
      state.permissionList = routers
      state.routerList = constantRouterMap.concat(routers) // 合并constant路由,得到最终的路由表
    },
  },
  actions: {
    GetRouterList({ commit }, role) {
      return new Promise((resolve, reject) => {
        try {
          const permissionRouter = filterAsyncRouter(asyncRouterMap, role) // permissionRouter 这就是过滤后的权限路由表
          console.log(permissionRouter, 'permissionRouter')
          commit('SET_ROUTER_LIST', permissionRouter)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
  },
}

export default permission
